import React, {useEffect} from 'react';
import LoginUnicoController from '../controller/login-unico.controller';

export default function LoginUnico() {
  const controller = new LoginUnicoController();

  useEffect(() => {
    controller.init().then(res => true);
  }, []);

  return <></>;
}
